import { createSelector } from 'utils/app.util';

export const getEventsFromState = createSelector(
  (state) => state.getIn(['projects', 'events', 'data']),
  (events) => events,
);
